import React from 'react';
import { Growl } from 'primereact/growl';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { Card } from 'primereact/card';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Message } from 'primereact/message';


import servicioCarril from '../servicios/ServicioCarril';
import servicioFacturacionEmergencia from '../servicios/ServicioFacturacionEmergencia';
import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';



export class Carril extends React.Component {
  constructor() {
    super();
    this.state = {
      carril: {},
      paginacion: { registrosPorPagina: 20, join: {'tcPlazaCobro':'alias_tcPlazaCobro'}},
      inicio: 0,
      plazasCobro: [],
      seleccionPlazaCobro: null,
      modalCarril: false,
      erroresCarril: {},
      estados_carril: [
        { name: 'Activo', code: 1 },
        { name: 'Desactivado', code: 0 }
      ],
      confirmacionEliminarCarril:false
    }

  }

  componentDidMount() {
    this.buscar_plazas_cobro_asignadas();
    //this.obtener_pagina();

  }

  buscar_plazas_cobro_asignadas = () => {
    servicioFacturacionEmergencia.plazas_asignadas_emisor().then(response => {
      if (response.data.error)
        this.growl.show({ life: 6000, severity: 'error', summary: 'error', detail: response.data.mensaje });
      else
        this.setState({ plazasCobro: response.data.lista });
    });
  }

  seleciona_plaza_cobro = (event) => {
    let { paginacion } = this.state;
    paginacion['restriccionesDinamicas']=[{tipoRestriccion:"eq",nombrePropiedad:"alias_tcPlazaCobro.numero",
    valorPropiedad:event.value.numero}];
    this.setState({ paginacion: paginacion, seleccionPlazaCobro: event.value });
    this.obtener_pagina();
  }

  nuevo_carril = () => {
    this.setState({ modalCarril: true, carril: {}, erroresCarril: {} });
  }

  pre_editar_carril = (rowData, column) => {
    return <div>
      <center>
      <div className="p-col-12 p-md-4">
        <Button type="button" icon="pi-md-edit" className="p-button-success" name="editar"
          tooltip="editar" onClick={(e) => this.pre_editar_cargar_valores(column.rowData)} >
        </Button>
      </div>
      </center>
    </div>;
  }

  pre_eliminar_carril=(rowData,column)=>{
      return <div>
        <center>
        <div className="p-col-12 p-md-4">
          <Button type="button" icon="pi-md-delete" className="p-button-warning" name="eliminar"
            tooltip="eliminar" onClick={(e) => this.pre_eliminar_cargar_valores(column.rowData)} >
          </Button>
        </div>
        </center>
      </div>;
  }

  pre_editar_cargar_valores = (objeto) => {
    let { estados_carril } = this.state;
    let estado_carril = estados_carril.filter(obj => {
      return obj.code === objeto.estado;
    });
    var carrilEditar = JSON.parse(JSON.stringify(objeto));
    let estado = estado_carril[0];
    delete carrilEditar['estado'];
    carrilEditar.estado = estado;
    this.setState({ carril: carrilEditar, modalCarril: true });
  }

  pre_eliminar_cargar_valores =(objeto)=>{
      this.setState({carril:objeto,confirmacionEliminarCarril:true})
  }

  cambiar_pagina = (event) => {
    let { paginacion } = this.state;

    paginacion.numeroPagina = event.page;
    paginacion.registrosPorPagina = event.rows;
    this.setState({ inicio: event.first, paginacion });
    this.obtener_pagina();
  }

  obtener_pagina() {
    let { paginacion } = this.state;
    servicioCarril.paginacion(paginacion).then((response) => {
      this.growl.show({ life: 4000, severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });

    //  if (response.data.error === false)
        this.setState({ paginacion: response.data.objeto });


    }).catch((error) => {
      if (error)
        return this.growl.show({ life: 4000, severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
    });

  }

  columna_estatus = (rowData, column) => {
    if (rowData.estado === 1)
      return <p style={{ backgroundColor: '#33ff4c', borderWidth: 1, borderColor: '#000', borderRadius: 12, padding: 8}}>Activo</p>;
    else
      return <p style={{ backgroundColor: '#f008', borderWidth: 1, borderColor: '#000', borderRadius: 12, padding: 8 }}>Desactivado</p>
  }

  cerrar_modal_carril = () => {
    this.setState({ modalCarril: false });
  }

  asignarValoresObjeto = (event) => {
    servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, true);
  }

  guardar_carril = () => {
    let { carril, paginacion } = this.state;
    let erorres = this.validar_formulario(carril);
    this.setState({ erroresCarril: erorres });
    if (!Object.keys(erorres).length) {
      var carrilEnvio = JSON.parse(JSON.stringify(carril));
      let estado = carrilEnvio.estado.code;
      delete carrilEnvio['estado'];
      carrilEnvio.estado = estado;
      servicioCarril.guardar_actualizar(carrilEnvio).then(response => {
        this.growl.show({ life: 4000, severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
        if (response.data.error === false) {
          this.setState({ carril: {}, modalCarril: false, erroresCarril: {} });
          if (Object.keys(paginacion.conjunciones).length === 1)
            this.obtener_pagina();
        }


      })

    }
  }

  validar_formulario = (carril) => {
    const erroresRequeridos = {};

    if (!carril.numero) {
      erroresRequeridos.numero = "El número es requerido";
    }
    if (!carril.estado) {
      erroresRequeridos.estado = "El estado es requerido";
    }
    if (!carril.tcPlazaCobro) {
      erroresRequeridos.tcPlazaCobro = "La plaza de cobro es requerida";
    }

    return erroresRequeridos;
  }

  cerrar_modal_confirmacion_eliminar_carril=()=>{
    this.setState({confirmacionEliminarCarril:false});
  }

  eliminar_carril=()=>{
    let {carril,paginacion}=this.state;
    servicioCarril.eliminar(carril).then(response=>{
      this.growl.show({ life: 4000, severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
      if (response.data.error === false) {
        this.setState({ carril: {}, confirmacionEliminarCarril: false, erroresCarril: {} });
        if (Object.keys(paginacion.conjunciones).length === 1)
          this.obtener_pagina();
      }
    });

  }

  buscar_carril_por_numero=()=>{
    let {carril}=this.state;
    servicioCarril.buscar_carril_por_numero({numero:carril.numero}).then(response=>{
      if (response.data.error) {
        carril['numero'] = '';
        this.setState({ carril });
        this.growl.show({ life: 7000, severity: 'error', summary: 'error', detail: response.data.mensaje });
      }

    });
  }

  render() {
    let { paginacion, inicio, carril, erroresCarril, estados_carril, plazasCobro } = this.state;



    const dialogFooterCarril = (
      <div>
        <Button icon="pi-md-check" onClick={this.guardar_carril} label="Guardar" className="teal-btn flat-btn" />
        <Button icon="pi-md-close" onClick={this.cerrar_modal_carril} label="Cancelar" className="p-button-danger flat-btn" />
      </div>
    );

    const dialogFooterConfirmacionEliminarCarril = (
      <div>
        <Button icon="pi-md-check" onClick={this.eliminar_carril} label="Si estoy seguro" className="teal-btn flat-btn" />
        <Button icon="pi-md-close" onClick={this.cerrar_modal_confirmacion_eliminar_carril} label="No estoy seguro" className="p-button-danger flat-btn" />
      </div>
    );

    return (<div>
      <Growl ref={(el) => this.growl = el} />

      <div className="card card-w-title">
        <h1 style={{marginBottom:'30px'}}>Administración de Carril</h1>
        <div className="p-grid p-fluid">
          <div className="p-col-12 p-md-4">
            <Button type="button" className="blue-grey-btn flat-btn" label="Nuevo Carril" name="nuevo" value="Nuevo"
              tooltip="Nuevo carril" onClick={this.nuevo_carril} >
            </Button>
          </div>
        </div>


      </div>

      <div className="card card-w-title">
        <div className="p-grid p-fluid">
          <div className="p-col-6">
            <p style={{fontSize:'14px', fontWeight:'bold', marginLeft:'5px'}}>Buscar por Plaza de Cobro:</p>
            <Dropdown style={{marginLeft:'5px'}} placeholder="Selecciona la plaza de cobro" options={plazasCobro} value={this.state.seleccionPlazaCobro} onChange={this.seleciona_plaza_cobro} autoWidth={false} optionLabel="nombre" />
          </div>
        </div>

      </div>

      <Card style={{marginBottom:'50px'}}>
        <DataTable value={paginacion.datos} responsive={true} header="MIS CARRILES">
          <Column style={{textAlign:'center'}} field="numero" header="Número carril" autoLayout={true} />
          <Column style={{textAlign:'center'}} body={this.columna_estatus} header="Estatus" autoLayout={true} />
          <Column style={{textAlign:'center'}} field="tcPlazaCobro.nombre" header="Nombre de la plaza de cobro" autoLayout={true} />
          <Column style={{textAlign:'center'}} field="tcPlazaCobro.numero" header="Número de la plaza de cobro" autoLayout={true} />
          <Column style={{textAlign:'center'}} header="Editar" body={this.pre_editar_carril.bind(this)} autoLayout={true} />
          <Column style={{textAlign:'center'}} header="Eliminar" body={this.pre_eliminar_carril.bind(this)} autoLayout={true} />
        </DataTable>
        <Paginator first={inicio} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiar_pagina.bind(this)} rowsPerPageOptions={[20, 40, 60, 80, 100]} />
      </Card>

      <Dialog header="Carril, los campos con * son requeridos." visible={this.state.modalCarril} modal={true} style={{ width: '60vw' }} footer={dialogFooterCarril} onHide={this.cerrar_modal_carril}>
        <div className="p-grid p-fluid">
          <div className="p-col-12 p-md-2">
            <label htmlFor="numero">* Número carril:</label>
          </div>
          <div className="p-col-12 p-md-4">
            <InputText id="numero" name="carril.numero" value={carril.numero || ''} onChange={this.asignarValoresObjeto} className={erroresCarril.numero ? 'p-error' : ''} onBlur={this.buscar_carril_por_numero} />
            {erroresCarril.numero ? <div> <Message severity="error" text={erroresCarril.numero} /> </div> : null}
          </div>
          <div className="p-col-12 p-md-2">
            <label htmlFor="estado">* Estado:</label>
          </div>
          <div className="p-col-12 p-md-4">
            <Dropdown id="estado" name="carril.estado" options={estados_carril} value={carril.estado} onChange={this.asignarValoresObjeto} placeholder="Selecciona" optionLabel="name" className={erroresCarril.estado ? 'p-error' : ''} />
            {erroresCarril.estado ? <div> <Message severity="error" text={erroresCarril.estado} /> </div> : null}
          </div>
          <div className="p-col-12 p-md-2">
            <label htmlFor="tcPlazaCobro">* Plaza de cobro:</label>
          </div>
          <div className="p-col-12 p-md-10">
            <Dropdown id="tcPlazaCobro" name="carril.tcPlazaCobro" options={plazasCobro} value={carril.tcPlazaCobro} onChange={this.asignarValoresObjeto} placeholder="Selecciona" optionLabel="nombre" className={erroresCarril.tcPlazaCobro ? 'p-error' : ''} />
            {erroresCarril.tcPlazaCobro ? <div> <Message severity="error" text={erroresCarril.tcPlazaCobro} /> </div> : null}
          </div>
        </div>
      </Dialog>


      <Dialog header="Confirmación" visible={this.state.confirmacionEliminarCarril} modal={true} style={{ width: '30vw' }} footer={dialogFooterConfirmacionEliminarCarril} onHide={this.cerrar_modal_confirmacion_eliminar_carril}>
        <h2>¿Estás seguro de eliminar el carril?</h2>
      </Dialog>



    </div>)
  }


}